module.exports = __webpack_public_path__ + "img/hk_2.676dec80.png";